require('es6-promise').polyfill()
require('es6-shim')
require('imports?jQuery=jquery!bootstrap')
require('font-awesome-sass-loader')
require('../modules/jquery-ui/ui/widgets/datepicker')
require('../modules/jquery-ui/ui/i18n/datepicker-ja')
var $ = window.jQuery = require('jquery')
import '../node_modules/jquery-ui/themes/base/datepicker.css'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './components/App'
import DatePicker from './components/DatePicker'

import router from './router'
import rootStore from './store'
import focus from 'vue-focus'

// 多言語対応
import vuexI18n from 'vuex-i18n'
import i18n from './i18n'

Vue.use(Vuex)

const store = new Vuex.Store(rootStore)
Vue.use(vuexI18n.plugin, store)

// 設定可能言語
Vue.i18n.add('ja', i18n.ja)
// 使用言語
Vue.i18n.set('ja')

$.datepicker.setDefaults($.datepicker.regional['ja'])

// 開発ツールを有効化
Vue.config.devtools = true

Vue.component('date-picker', DatePicker)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App },
  directives: { focus: focus }
})



// WEBPACK FOOTER //
// ./src/main.js